export const breakpoints = {
  xs: '390px',
  sm: '480px',
  md: '640px',
  lg: '768px',
  xl: '1024px',
};

export type BreakpointTypes = keyof typeof breakpoints;
